import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'

import { trackGAEvent } from '../utilities/tracking'
import { PlantListHeader, PlantListSearch, SearchCancel, SearchClear } from '../StyledComponents/Plants/PlantList'
import { FillerDiv } from '../StyledComponents/Fillers'

const WAIT_INTERVAL = 800
const ENTER_KEY = 13

class SearchHeader extends Component {
    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
        this.triggerChange = this.triggerChange.bind(this)
    }

    componentWillMount() {
        this.timer = null
    }

    handleChange(e) {
        clearTimeout(this.timer)

        this.props.onSearchQueryChange(e.target.value)

        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL)
    }

    handleKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange()
        }
    }

    triggerChange() {
        const {
            searchQuery, onSearchTrigger, searchFilters, userSession,
        } = this.props
        trackGAEvent('interaction', {
            interaction_value: 'undefined',
            interaction_category: 'Plant-List',
            interaction_action: 'plant-search-request',
            interaction_label: `${userSession.gardenKnowledge || 'NOT_SPECIFIED'}`,
        })
        onSearchTrigger(searchQuery, searchFilters)
    }

    render() {
        const {
            searchActive, onSearchClose, searchQuery, onSearchClear,
        } = this.props

        if (!searchActive) {
            return null
        }

        const clearIcon = isEmpty(searchQuery)
            ? null
            : <SearchClear onClick={onSearchClear} name="times" />

        return (
            <FillerDiv>
                <PlantListHeader>
                    <FillerDiv className="container">
                        <FillerDiv className="row">
                            <FillerDiv className="col-9">
                                <PlantListSearch
                                    className="col-12"
                                    type="search"
                                    placeholder="Suche..."
                                    value={searchQuery}
                                    onChange={this.handleChange}
                                    onKeyDown={this.handleKeyDown}
                                />
                                {clearIcon}
                            </FillerDiv>
                            <SearchCancel className="col-3" onClick={onSearchClose}>
                                Abbrechen
                            </SearchCancel>
                        </FillerDiv>
                    </FillerDiv>
                </PlantListHeader>
            </FillerDiv>
        )
    }
}

export default SearchHeader



// WEBPACK FOOTER //
// ./src/components/Plant/SearchHeader.js